import { render, staticRenderFns } from "./DetailsDataListParts.vue?vue&type=template&id=b4e0389c&scoped=true"
import script from "./DetailsDataListParts.vue?vue&type=script&lang=ts"
export * from "./DetailsDataListParts.vue?vue&type=script&lang=ts"
import style0 from "./DetailsDataListParts.vue?vue&type=style&index=0&id=b4e0389c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e0389c",
  null
  
)

export default component.exports